export default __webpack_public_path__ + "static/media/README.aad386a5.md";